import type { RecordData } from 'webapp-types';
import { ModelName } from 'webapp/enums/enums';

import BufferedModel from 'webapp/models-custom/buffer/buffered-model';
import type GroupRecord from 'webapp/models/group';

export default class Group extends BufferedModel<GroupRecord, RecordData.Group.Serialized> {
	// ------- props from / to ED record ------

	get id() {
		return this.model.id;
	}

	get name(): string {
		return this.getBuffered('name');
	}

	set name(value: string) {
		this.setBuffered('name', value);
	}

	get description(): string | null {
		return this.getBuffered('description');
	}

	set description(value: string | null) {
		this.setBuffered('description', value);
	}

	get color(): string {
		return this.getBuffered('color');
	}

	set color(value: string) {
		this.setBuffered('color', value);
	}

	// ------- other props ------

	static override modelName = ModelName.GROUP; // store record type
}
